import { useState, useEffect, createContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
// import store from "./redux";
// import storeRtk from "./rtk/app/store"; // store as storeRtk
import store from "./rtk/app/store";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./app.css";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import Home from "./pages/home/Home";
import Portfolio from "./pages/portfolio/Portfolio";
import Yields from "./pages/yields/Yields";
import Charts from "./pages/charts/Charts";
import YieldsData from "./pages/yieldsData/YieldsData";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import NewProduct from "./pages/newProduct/NewProduct";
import Vaults from "./pages/vaults/Vaults";
import AddVault from "./pages/crudSql/addVault/AddVault";
import AddBalRwd from "./pages/crudSql/addBalRwd/AddBalRwd";
import Wallets from "./pages/wallets/Wallets";
import WalletsBalances from "./pages/walletsBalances/WalletsBalances";
import Login from "./pages/login/Login";
import Alerts from "./pages/alerts/Alerts";
import Notifications from "./pages/notifications/Notifications";
import Withdraw from "./pages/crudSql/withdraw/Withdraw";
import Deposit from "./pages/crudSql/deposit/Deposit";
import Claim from "./pages/crudSql/claim/Claim";
// import {
//   NotificationSnackbarProvider,
//   displayNotification,
// } from "./components/mui/snackbar/NotificationSnackbarProvider";
// import SnackbarContext from "./context/SnackbarContext";
//import store from "./redux/store";
// import { toastExpiredWallets } from "./components/common/toasts";

// web3
// const contractAddress = "0x355638a4eCcb777794257f22f50c289d4189F245";
// const abi = contract.abi;

export const Web3Context = createContext();

function App() {
  const [userId, setUserId] = useState(1);

  const [userAuthWallet, setUserAuthWallet] = useState(""); // "0xC91F6b41B475287b49a22d2e606AdE70E255C5D1"
  const [userWallets, setUserWallets] = useState([]);
  const [authWalletData, setAuthWalletData] = useState({});
  const [newWallets, setNewWallets] = useState([]);
  const [smUserBalanceUsd, setSmUserBalanceUsd] = useState(0);
  const [smUserBalanceDw, setSmUserBalanceDw] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  const [dateRange, setDateRange] = useState(
    JSON.parse(localStorage.getItem("dateRange")) ?? "1M"
  );
  const [intervalRange, setIntervalRange] = useState(
    JSON.parse(localStorage.getItem("intervalRange")) ?? "1D"
  );

  // local storage ____________________________________________________________________
  useEffect(() => {
    localStorage.setItem("dateRange", JSON.stringify(dateRange));
  }, [dateRange]);

  useEffect(() => {
    localStorage.setItem("intervalRange", JSON.stringify(intervalRange));
  }, [intervalRange]);
  // /local storage ____________________________________________________________________

  const getWallets = () => {
    const apiUrl = "/wallets";
    const url =
      process.env.REACT_APP_CRUD_SRV +
      apiUrl +
      "?auth=" +
      userAuthWallet +
      "&cs=" +
      sha256(apiUrl + userAuthWallet + process.env.REACT_APP_SECRET);
    if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
    Axios.get(url).then((res) => {
      // console.log("/wallets? =", res.data.response);
      if (res.data.response.wallets.length > 0) {
        setUserWallets(res.data.response.wallets);

        const authWalletRow = res.data.response.wallets.filter(
          (wallet) => wallet.wallet == userAuthWallet
        );
        setAuthWalletData(authWalletRow[0]);
      }

      if (res.data.response.newWallets.length > 0) {
        setNewWallets(res.data.response.newWallets);
      }

      // console.log("dbg=", process.env.REACT_APP_IS_DBG, userAuthWallet, process.env.REACT_APP_SECRET);
      // if (process.env.REACT_APP_IS_DBG)
      //   console.log("useEffect.userWallets=", userWallets); // -- is not working - but works fine later outside useEffect
    });
  };

  const getUserBalance = () => {
    const apiUrl = "/user/balance";
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        apiUrl +
        "?auth=" +
        userAuthWallet +
        "&cs=" +
        sha256(apiUrl + userAuthWallet + process.env.REACT_APP_SECRET)
      // bcrypt(userAuthWallet, process.env.REACT_APP_SECRET)
    ).then((res) => {
      if (res.data?.status == 200)
        setSmUserBalanceUsd(+res.data.response.toFixed(2)); //[0].smUserBalanceUsd
    });
  };

  const getUserData = () => {
    const apiUrl = "/user/data";
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        apiUrl +
        "?auth=" +
        userAuthWallet +
        "&cs=" +
        sha256(apiUrl + userAuthWallet + process.env.REACT_APP_SECRET)
    ).then((res) => {
      if (
        res.data?.balanceUsd.status == "fulfilled" &&
        res.data.balanceUsd.value.status == 200
      ) {
        // console.log(res.data.balanceUsd);
        setSmUserBalanceUsd(+res.data.balanceUsd.value.response.toFixed(2));
      }

      if (
        res.data?.balanceDw.status == "fulfilled" &&
        res.data.balanceDw.value.status == 200
      ) {
        // console.log(res.data.balanceDw);
        setSmUserBalanceDw(+res.data.balanceDw.value.response.toFixed(2));
      }
    });
  };

  const getNotificationCount = () => {
    const apiUrl = "/notifications/count";
    const url =
      process.env.REACT_APP_CRUD_SRV +
      apiUrl +
      "?auth=" +
      userAuthWallet +
      "&cs=" +
      sha256(apiUrl + userAuthWallet + process.env.REACT_APP_SECRET);
    if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
    Axios.get(url).then((res) => {
      if (res.data?.status == 200)
        setNotificationCount(+res.data.response.data[0].cnt);
    });
  };

  // useEffect(() => {
  //   if (userAuthWallet != "") getWallets();
  // }, [userAuthWallet]);

  useEffect(() => {
    if (userAuthWallet != "") {
      getWallets();
      // getUserBalance();
      getUserData();
      getNotificationCount();
    }
  }, [userAuthWallet]);

  // const { pathName } = useLocation();

  // useEffect(() => {
  //   if (userAuthWallet != "") {
  //     toastExpiredWallets(userWallets, userAuthWallet);
  //   }
  // }, [userWallets, pathName]);

  // useEffect(() => {
  //   console.log("authWalletData", authWalletData);
  // }, [authWalletData]);

  // web3

  // const checkWalletIsConnected = () => {};

  // const connectWalletHandler = () => {};

  // useEffect(() => {
  //   checkWalletIsConnected();
  // }, []);

  // /web3

  return (
    // <Provider storeRtk={storeRtk}>
    <Provider store={store}>
      <Web3Context.Provider
        value={{
          userAuthWallet,
          setUserAuthWallet,
          userWallets,
          setUserWallets,
        }}
      >
        {/* <SnackbarContext.Provider> */}
        {/* <NotificationSnackbarProvider>
          <button onClick={displayNotification(["Msg1", "Msg2"])}>
            Display
          </button> */}

        <Router>
          {/* <Topbar /> */}
          <div
            className={"rootContainer" + (userAuthWallet ? " loggedOn" : "")}
          >
            <Sidebar
              userAuthWallet={userAuthWallet}
              notificationCount={notificationCount}
            />

            <div className="payload">
              <Topbar
                userAuthWallet={userAuthWallet}
                userWallets={userWallets}
                smUserBalanceUsd={smUserBalanceUsd}
                smUserBalanceDw={smUserBalanceDw}
                newWallets={newWallets}
              />

              <Switch>
                <Route exact path="/">
                  <Home />
                </Route>

                <PrivateRoute path="/portfolio" isAuth={userAuthWallet}>
                  {/*<Provider store={store}>*/}
                  <Portfolio userAuthWallet={userAuthWallet} />
                  {/*</Provider>*/}
                </PrivateRoute>

                {/* <PrivateRoute path="/yields" isAuth={userAuthWallet}>
                  <Yields dateRange={dateRange} setDateRange={setDateRange} />
                </PrivateRoute> */}

                <PrivateRoute path="/charts" isAuth={userAuthWallet}>
                  <Charts
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    intervalRange={intervalRange}
                    setIntervalRange={setIntervalRange}
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute
                  path="/vaults/add/balance"
                  isAuth={userAuthWallet}
                >
                  <AddBalRwd
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute path="/vaults/withdraw" isAuth={userAuthWallet}>
                  <Withdraw
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute path="/vaults/claim" isAuth={userAuthWallet}>
                  <Claim
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute path="/vaults/deposit" isAuth={userAuthWallet}>
                  <Deposit
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute path="/vaults/add" isAuth={userAuthWallet}>
                  <AddVault
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <Route path="/vaults">
                  <Vaults
                    userAuthWallet={userAuthWallet}
                    balanceDw={smUserBalanceDw}
                  />
                </Route>

                <PrivateRoute path="/wallets/balances" isAuth={userAuthWallet}>
                  <WalletsBalances
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute path="/wallets" isAuth={userAuthWallet}>
                  <Wallets
                    smUserBalanceUsd={smUserBalanceUsd}
                    getUserBalance={getUserBalance}
                    getWallets={getWallets}
                    userWallets={userWallets}
                    setUserWallets={setUserWallets}
                    userAuthWallet={userAuthWallet}
                    authWalletData={authWalletData}
                  />
                </PrivateRoute>

                <PrivateRoute path="/account/alerts" isAuth={userAuthWallet}>
                  <Alerts
                    userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                  />
                </PrivateRoute>

                <PrivateRoute
                  path="/account/notifications"
                  isAuth={userAuthWallet}
                >
                  <Notifications
                    // userWallets={userWallets}
                    userAuthWallet={userAuthWallet}
                    setNotificationCount={setNotificationCount}
                  />
                </PrivateRoute>

                {/* <Route path="/yields-data">
                  <YieldsData />
                </Route> */}

                {/* <Route path="/users">
                  <UserList />
                </Route>
                <Route path="/user/:userId">
                  <User />
                </Route>
                <Route path="/newUser">
                  <NewUser />
                </Route>
                <Route path="/products">
                  <ProductList />
                </Route>
                <Route path="/product/:productId">
                  <Product />
                </Route>
                <Route path="/newProduct">
                  <NewProduct />
                </Route> */}

                <Route path="/login">
                  <Login />
                </Route>

                {/* <Route path="*">
                  <NoFoundComponent />
                </Route> */}
              </Switch>
            </div>
          </div>
        </Router>
        {/* </NotificationSnackbarProvider> */}
        {/* </SnackbarContext.Provider> */}
        <ToastContainer autoClose={3000} />
      </Web3Context.Provider>
    </Provider>
    // </Provider>
  );
}

export default App;
